import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import AboutStats from './components/AboutStats';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';
import { usePageSEO, SITE_DOMAIN } from '@/hooks/usePageSEO';

export default function Home() {
  usePageSEO({
    title: 'Best Sugargoo Spreadsheet 2026 | Updated Finds & Shopping Guides',
    description: 'Discover the latest Sugargoo Spreadsheet links, sneaker finds, clothing spreadsheets, seller guides, QC tips, shipping tutorials and safe shopping resources. Updated daily with verified links across 14+ categories.',
    keywords: 'Sugargoo Spreadsheet, Sugargoo finds, Sugargoo links, Sugargoo spreadsheet 2026, Sugargoo shopping guide, Sugargoo QC, Sugargoo shipping',
    canonicalUrl: `${SITE_DOMAIN}/`,
    ogType: 'website',
    lastModified: '2026-06-18',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'SugargooSpreadsheet.run',
        url: SITE_DOMAIN,
        description: 'The most comprehensive Sugargoo Spreadsheet resource website. Find updated spreadsheet links, shopping guides, QC tips, and verified seller information.',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'SugargooSpreadsheet.run',
        url: SITE_DOMAIN,
        description: 'The most comprehensive Sugargoo Spreadsheet resource website.',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_DOMAIN}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <AboutStats />
        <CategoryGrid />
        <ArticlePreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}